export default "__VITE_ASSET__BVClU3gE__"